import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
// import HomePage from "./pages/HomePage";
// import AboutPage from "./pages/AboutPage";
// import LibraryOverviewPage from "./pages/Programs/LibraryOverviewPage";
// import CommunityPage from "./pages/CommunityPage";
// import RetreatsPage from "./pages/RetreatsPage";
// import DonatePage from "./pages/DonatePage";
// import Success from "./pages/SuccessError/Success";
// import Errors from "./pages/SuccessError/Error";
import CustomCursor from "./components/CustomCursor";
import NewAboutPage from "./NewComponent/AboutPageAll/NewAboutPage";
import HowItWorks from "./NewComponent/HowItWorks";
import InvestorSection from "./NewComponent/InvestorSection";
import NewPrograms from "./NewComponent/ProgramsMenu/NewPrograms";
import NewServices from "./NewComponent/Services/NewServices";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermAndConditionPage from "./pages/TermAndConditionPage";
import NewHomePage from "./NewComponent/HomePageAll/NewHomePage";
// import ChatGPT from "./NewComponent/HomePageAll/ChatGPT";


function App() {

  return (
    <>
      <CustomCursor />
      <BrowserRouter>
        <Routes>
          {/* <Route path="/" element={<ChatGPT />} /> */}
          <Route path="/" element={<NewHomePage />} />
          <Route path="/about-us" element={<NewAboutPage />} />
          <Route path="/programs/specific-programs" element={<NewPrograms />} />
          <Route path="/services/personalized-programs" element={<NewServices />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/investors" element={<InvestorSection />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/term" element={<TermAndConditionPage />} />
          {/* <Route path="/" element={<HomePage />} /> */}
          {/* <Route path="/about" element={<AboutPage />} /> */}
          {/* <Route path="/service" element={<LibraryOverviewPage />} /> */}
          {/* <Route path="/programs/specific-programs" element={<SpecificPrograms />} /> */}
          {/* <Route path="/programs/user-profiles" element={<UserProfiles />} />
          <Route path="/programs/library-overview" element={<LibraryOverview />} />
          <Route path="/programs/corporate-wellness" element={<CorporateWellnessPrograms />} />
          <Route path="/programs/fitness-wellness" element={<FitnessWellnessPrograms />} />
          <Route path="/programs/mental-health" element={<MentalHealthPrograms />} />
          <Route path="/programs/sports-athletics" element={<SportsAthleticsPrograms />} />
          <Route path="/programs/nutrition" element={<NutritionPrograms />} />
          <Route path="/programs/education" element={<EducationPrograms />} /> */}
          {/* Services */}

          {/* <Route path="/restreat" element={<RetreatsPage />} />
          <Route path="/invest" element={<CommunityPage />} />
         
          <Route path="/donate" element={<DonatePage />} />
          <Route path="/success" element={<Success />} />
          <Route path="/error" element={<Errors />} /> */}
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
